<template>
  <div class="main">
    <c-panel>
      <form-pnae :paramId="$route.params.id" v-on:onSubmitPnae="onSubmitPnae"></form-pnae>
    </c-panel>
  </div>
</template>
<script>
import formPnae from "./form"

export default {
  methods: {
    onSubmitPnae () {
      this.$router.push('/admin/merenda/pnae-parametros')
    }
  },
  components: { formPnae }
}
</script>
